const callForContentConfig = {
  proposalsCapNumber: 6,
  homelandSessionLimit: 6,

  sponsorSessionLimits: {
    PLATINUM: 20,
    GOLD: 15,
    SILVER: 12,
    BRONZE: 8,
    SOCIETY: 5,
  },

  SAVING_STATE: {
    DRAFT: 'DRAFT',
    SUBMIT: 'SUBMIT',
  },
}

export default callForContentConfig
